module.exports = {"purchase":"Purchase","notAvailable":"Not available","unlock":"Unlock","unlocked":"Unlocked"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/Flexpass/locales/fr.json
// module id = 1137
// module chunks = 0